// extracted by mini-css-extract-plugin
module.exports = {"ratingsWrapper":"styles_ratingsWrapper__2SDAw","filter":"styles_filter__oTy8R"};